module.exports = __webpack_public_path__ + "/f6439ecf8db6c9f35ea880e5987a141b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/notification_icon@2x.png
 ** module id = 725
 ** module chunks = 0 1
 **/